<template>
  <div>
    <a-row :gutter="5">
      <a-col :span="24">
        <a-row :gutter="16">
          <a-col :span="12">
            <!-- <a-card style="height:200px;">
              <div class="flex1">
                <div class="order">订单待处理</div>
              </div>
              <div class="flex">
                <div style="background-color:#38C1CF;border-radius: 12px;margin-right:5%;">
                  <div class="flex">
                    <img src="@/assets/workbench/workbench-1.svg" />
                    <div>
                      <p class="p1">
                        0
                      </p>
                      <p class="p2">
                        补价审核（单）
                      </p>
                    </div>
                  </div>
                </div>
                <div style="background-color:#FFAD49;border-radius: 12px;">
                  <div class="flex">
                    <img src="@/assets/workbench/workbench-2.svg" />
                    <div>
                      <p class="p1">
                        0
                      </p>
                      <p class="p2">
                        好评审核（单）
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </a-card> -->
            <a-card style="height:230px">
              <div class="flex">
                <div class="pd-20">
                  <div class="center">
                    <img src="@/assets/logo3.png" alt="" style="width: 90px;height: 100px;" />
                  </div>
                  <div class="center mt-15 bold">{{ enterpriseName }}</div>
                </div>
                <div>
                  <div class="center">账户余额</div>
                  <div class="blue center size-34 bold">￥{{ totalBalance }}</div>
                  <div class="center ">
                    <router-link to="/wallet/recharge">
                      <a-button type="primary" class="mr-20">
                        立即充值
                      </a-button>
                    </router-link>
                    <router-link to="/wallet/walletList">
                      <a-button type="Default" plain>
                        消费明细
                      </a-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card style="height:230px">
              <div class="flex1">
                <div class="order">订单时效</div>
                <a-popover trigger="hover" placement="rightTop" >
                  <template slot="content">
                    <p>未预约：未派给团队和接单未联系客户的订单。</p>
                    <p>未安装：已联系客户还未安装的订单。</p>
                  </template>
                  <template slot="title">订单时效：时效（最近30天） </template>
                  <img class="remind" src="@/assets/workbench/workbench-3.svg"/>
                </a-popover>
              </div>
              <div ref="orderChart" style="height:150%;width:100%" class="center"></div>
            </a-card>
          </a-col>
        </a-row>
        <a-row style="margin-top:16px">
          <a-col>
            <a-card class="height:230px">
              <div class="flex1">
                <div class="order">订单概况</div>
                <a-popover trigger="hover" placement="rightTop" >
                  <template slot="content">
                    <p>已建单：商家下所有订单</p>
                    <p>已下单：已下订单没有安排团队的订单</p>
                    <p>已派单：已派出给服务团队的订单</p>
                    <p>已接单：已由服务团队确认受理的订单</p>
                    <p>已预约：已与客户预约完成上门时间的订单</p>
                    <p>已安装：上传完现场服务照片的订单且审核通过</p>
                  </template>
                  <template slot="title">
                    <p style="width:300px">&nbsp&nbsp时效（最近30天）:由于服务器缓存，以及计算方法和统计时间的差异，数据可能与实际订单状态存在极微小误差，请以实际订单状态为准</p>
                  </template>
                  <img class="remind" src="@/assets/workbench/workbench-3.svg"/>
                </a-popover>
              </div>
              <div style="display:flex;justify-content:space-between;align-items:center">
                <div style="text-align:center" @click="toStatus('orderTotal')">
                  <a-badge
                    :count="lawandOrder.orderTotal"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus "
                    src="@/assets/workbench/lawandorder-1.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已建单</p>
                </div>
                <div style="text-align:center" @click="toStatus('receiveOrder')">
                  <a-badge
                    :count="lawandOrder.receiveOrder"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus"
                    src="@/assets/workbench/lawandorder-5.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已派单</p>
                </div>
                <div style="text-align:center" @click="toStatus('reservationOrder')">
                  <a-badge
                    :count="lawandOrder.orderPlaced"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus "
                    src="@/assets/workbench/lawandorder-3.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已接单</p>
                </div>
                <div style="text-align:center" @click="toStatus('installOrder')">
                  <a-badge
                    :count="lawandOrder.installOrder"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus "
                    src="@/assets/workbench/lawandorder-4.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已预约</p>
                </div>
                <div style="text-align:center" @click="toStatus('dispatchOrder')">
                  <a-badge
                    :count="lawandOrder.dispatchOrder"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus"
                    src="@/assets/workbench/lawandorder-2.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已下单</p>
                </div>
                <div style="text-align:center" @click="toStatus('completeOrder')">
                  <a-badge
                    :count="lawandOrder.completeOrder"
                    :offset="[0, 10]"
                    :overflow-count="9999"
                  ><img
                    class="imgStatus "
                    src="@/assets/workbench/lawandorder-6.svg"
                  /></a-badge>
                  <p style="margin-top:10px">已安装</p>
                </div>
              </div>
            </a-card>
          </a-col>
          </a-card>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getWorkTable, getTime } from '@/api/dashboard/workbench'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'Workbench',
  data () {
    return {
      chart: null, // 图表实例
      enterpriseName: '',
      totalBalance: '',
      store,
      enterpriseId: this.$store.getters.enterpriseId, // 企业ID
      endTime: null,
      startTime: null,
      lawandOrder: {} // 订单概况
    }
  },
  created () {
    this.information() // 企业信息
    this.getWorkTable() // 获取工作台数据
    this.getTime() // 获取时间
  },
  mounted () {},
  methods: {
    init () {
      // 2.初始化
      this.chart = this.$echarts.init(this.$refs.orderChart)
      // 3.配置数据
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '3%',
          left: 'left',
          width: 20
        },
        color: ['#1A43A9', '#FFAD49', '#38C1CF'],
        series: [
          {
            name: '单位（单）',
            type: 'pie',
            radius: ['55%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.lawandOrder.reservationOrder, name: '未预约', name2: '1' },
              { value: this.lawandOrder.reviewOrder, name: '未安装', name2: '3' }
            ]
          }
        ]
      }
      // 4.传入数据
      this.chart.setOption(option)
      var _this = this
      this.chart.on('click', function (params) {
        _this.$router.push({
          name: 'qyOrderList',
          params: { unfinishTag: params.data.name2, endTime: _this.endTime, startTime: _this.startTime }
        })
      })
    },
    async getWorkTable () {
      try {
        const res = await getWorkTable()
        this.lawandOrder = res.data[0]
        this.init()
      } catch (err) {
        console.log(err)
      }
    },
    toStatus (Status) {
      this.$router.push({
        name: 'qyOrderList',
        params: {
          endTime: this.endTime,
          startTime: this.startTime,
          orderStatus: Status
        }
      })
    },
    async getTime () {
      try {
        const res = await getTime()
        this.endTime = res.data.endTime
        this.startTime = res.data.startTime
      } catch (err) {
        console.log(err)
      }
    },
    information () {
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${this.enterpriseId}`,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
      })
    }
  }
}
</script>
<style scoped lang="less">
img {
  width: 40%;
  height: 50%;
  padding-top: 5%;
  padding-bottom: 5%;
}
.imgStatus {
  width: 100%;
  height: 100%;
  padding-top: 5%;
  padding-bottom: 5%;
}
/deep/ canvas {
  aspect-ratio: auto 400 / 300;
  height: 200px;
}
.order {
  font-size: 20px;
  font-weight: bold;
  color: #1f2e4d;
  margin-bottom: 20px;
  padding-left:20px;
  border-left:4px solid #1f2e4d;
}
/deep/.ant-card-bordered {
  border: 0px solid #e8e8e8;
}
.p1 {
  font-size: 40px;
  color: #ffffff;
  margin-bottom: 0;
  text-align: center;
}
.p2 {
  font-size: 14px;
  color: #ffffff;
}
.remind {
  padding-bottom: 0px;
  padding-top:9px;
  padding-left:5px;
  width:20px;
}
</style>
